var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DAE3F1",
    fillRule: "evenodd",
    d: "M5.992 6.933C7.663 5.915 9.722 5.077 12 5.077s4.337.838 6.008 1.856c1.681 1.024 3.056 2.28 3.98 3.238l.075.079c.556.574 1.014 1.047 1.014 1.75s-.458 1.176-1.014 1.75l-.076.08c-.923.956-2.298 2.214-3.979 3.237-1.671 1.018-3.73 1.856-6.008 1.856s-4.337-.838-6.008-1.856c-1.681-1.023-3.056-2.28-3.98-3.238l-.075-.079C1.38 13.177.923 12.704.923 12s.458-1.176 1.014-1.75l.076-.08c.923-.956 2.298-2.213 3.979-3.237",
    clipRule: "evenodd"
  })));
};
export { SvgEyeClosed as ReactComponent };